import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import { FormPanelProps, FormSwitch, FormTextField } from "./formFields";

export function DriverTab({ form, setField, isMobile }: FormPanelProps) {
  const { t } = useTranslation();
  const bind = { form, setField };
  return (
    <Stack spacing={1.25}>
      <FormSwitch {...bind} field="isDriver" label={t("users.isDriver")} />
      <Stack direction={isMobile ? "column" : "row"} spacing={1.25}>
        <FormTextField {...bind} field="designation" label={t("users.designation")} />
        <FormTextField {...bind} field="employeeNo" label={t("users.employeeNo")} />
      </Stack>
      <FormTextField {...bind} field="carrierNumber" label={t("users.carrierNumber")} />
    </Stack>
  );
}
